import type { LocaleMessageBundle } from '../../types'
import { accountProfileMessages } from './account-profile'
import { authChangePasswordMessages } from './change-password'
import { authForgotPasswordMessages } from './forgot-password'
import { authLoginMessages } from './login'
import { authSplashMessages } from './splash'

export const authMessages: LocaleMessageBundle = {
  vi: {
    ...accountProfileMessages.vi,
    ...authLoginMessages.vi,
    ...authForgotPasswordMessages.vi,
    ...authChangePasswordMessages.vi,
    ...authSplashMessages.vi,
  },
  en: {
    ...accountProfileMessages.en,
    ...authLoginMessages.en,
    ...authForgotPasswordMessages.en,
    ...authChangePasswordMessages.en,
    ...authSplashMessages.en,
  },
}
